import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import {
  promotions,
  mobilePromo1,
  mobilePromo2,
  mobilePromo3,
  mobilePromo4,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center m="0 auto" w="100%">
          <CFImage src={mobilePromo1} w="100%" alt="Promotions" />
          <CFImage src={mobilePromo2} w="100%" alt="Promotions" />
          <CFImage src={mobilePromo3} w="100%" alt="Promotions" />
          <CFImage src={mobilePromo4} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="0 auto" w="100%">
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
